
import { TranslationRecord } from '../../types';

export const navigation: TranslationRecord = {
  // Navigation
  home: 'Αρχική',
  about: 'Σχετικά με το Loena',
  suites: 'Σουίτες',
  reviews: 'Κριτικές',
  contact: 'Επικοινωνία',
  
  // Additional navigation items
  gallery: 'Γκαλερί',
  amenities: 'Παροχές',
  booking: 'Κράτηση',
  blog: 'Loena Journal',
  
  // Menu items
  menu: 'Μενού',
  close: 'Κλείσιμο',
  
  // Language selector
  language: 'Γλώσσα',
  english: 'Αγγλικά',
  greek: 'Ελληνικά',
};
